import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { changeAutoProlong } from '../../../../redux/reducers';
import {
  selectAutoProlongHint,
  selectIsAutoProlongAvailable,
  selectIsAutoProlongChecked,
  selectIsAutoProlongDisabled,
} from '../../../../selectors/checkoutInfo';
import { AutoProlongDesktop } from './AutoProlong.desktop';
import { AutoProlongMobile } from './AutoProlong.mobile';

export const AutoProlongContainer = () => {
  const isMobile = useIsMobileDevice();

  const isChecked = useSelector(selectIsAutoProlongChecked);
  const isDisabled = useSelector(selectIsAutoProlongDisabled);
  const isAvailable = useSelector(selectIsAutoProlongAvailable);
  const hint = useSelector(selectAutoProlongHint);

  const dispatch = useDispatch<TDispatch>();

  const handleChangeValue = React.useCallback(() => dispatch(changeAutoProlong(!isChecked)), [dispatch, isChecked]);

  if (!isAvailable) {
    return null;
  }

  if (isMobile) {
    return <AutoProlongMobile value={isChecked} isDisabled={isDisabled} hint={hint} onChange={handleChangeValue} />;
  }

  return <AutoProlongDesktop value={isChecked} isDisabled={isDisabled} hint={hint} onChange={handleChangeValue} />;
};
